import React, { useEffect, useState } from "react";
// import React from 'react'

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { gettoken } from "../Localstorage/Store";
import Loginheader from "../components/Loginheader";
// import { TfiAlignJustify } from "react-icons/tfi";
// import { useLocation } from "react-router-dom";
export const Termsconditions = () => {
  const tokenvalue = gettoken();
  return (
    <div>
     {tokenvalue ? <Header /> : <Loginheader />} 



      <div>
          {/* breadcrumb start */}
  <div className={tokenvalue ? "breadcrumb-main marginfromtop" : "breadcrumb-main marginfromtop23"} style={{backgroundColor:"#fff"}}>
    <div className="container m-0">
      <div className="row">
        <div className="col">
          <div className="breadcrumb-contain">
            <div>
              <ul>
                <li><a href="/home">home</a></li>
                <li>{">"}</li>
                <li><a href="javascript:void(0)">Terms and Conditions</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* breadcrumb End */}
        <section className="section-big-pt-space pb-2" style={{backgroundColor:"#ececec"}}>
          <div className="col-lg-12 col-sm-12 col-xs-12 mt-lg-3 mt-xs-4 mb-5">
            <div className="container-fuild emp-profile">
              <div className="row profile2">
               

                <section className="tab-product-main-tab">
                <div className="container  py-4" style={{ 
      maxWidth: '1200px', 
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6'
    }}>
<h1
  className="mb-4"
  style={{
    color: '#2c3e50',
    fontWeight: '600',
    fontSize: '28px',
    borderBottom: '1px solid #eee',
    paddingBottom: '10px',
    textAlign: 'center' // center the text
  }}
>
  Terms of Use
</h1>

      
      <p style={{ marginBottom: '20px', fontSize: '15px' }}>
        Welcome to One Up Trade Private Limited ("us," "we," "our," or "the Company"). These Terms and Conditions ("Terms") govern your use of the website www.oneupshop.in (the "website"). Please read these Terms carefully before using our website. By accessing or using our website, you agree to be bound by these Terms. If you do not agree with these Terms, please do not use the website.
      </p>

      <h2 style={{ 
        color: '#2c3e50',
        margin: '25px 0 15px 0',
        fontWeight: '600',
        fontSize: '22px'
      }}>
        Use of the website
      </h2>

      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        1. Eligibility:
      </h3>
      <p style={{ marginBottom: '15px', fontSize: '15px' }}>
        You must be at least 18 years old to use our website. By using the website, you represent and warrant that you are at least 18 years old and have the legal capacity to enter into these Terms.
      </p>

      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        2. Customer Registration for Voucher Redemption:
      </h3>
      <p style={{ marginBottom: '10px', fontSize: '15px' }}>
        Customers must use a valid voucher to access the website. The process involves:
      </p>
      <ul style={{ 
  marginBottom: '15px',
  paddingLeft: '20px',
  fontSize: '15px',
  listStyleType: 'disc',
  display: 'block'  // Ensures vertical stacking
}}>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>Entering the valid voucher code.</li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>Providing a mobile number.</li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>Receiving an OTP (One-Time Password) via SMS.</li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>Entering the OTP to complete the "Voucher log-in" process and gain access to the website.</li>
</ul>


      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        3. Business Registration:
      </h3>
      <p style={{ marginBottom: '10px', fontSize: '15px' }}>
        This category is designated for B2B Clients. The process involves:
      </p>
      <ul style={{ 
  marginBottom: '10px',
  paddingLeft: '20px',
  fontSize: '15px',
  listStyleType: 'disc',
  display: 'block'
}}>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Submitting a duly filled Business Registration form.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Being provided with a unique User ID and Password upon approval.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Using the User ID and Password for 'Business log-in' to access the website.
  </li>
</ul>

      <p style={{ marginBottom: '15px', fontSize: '15px' }}>
        You agree to provide accurate, current, and complete information during the registration process and to keep your account information updated. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You must notify us immediately of any unauthorized use of your account.
      </p>

      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        4. Redemption of Voucher(s):
      </h3>
      <p style={{ marginBottom: '10px', fontSize: '15px' }}>
        Redemption of the Voucher(s) shall be strictly as per the 'Terms of Redemption' specified on/with the voucher(s) issued. 
        Use of Voucher(s) will be subject to the below given terms:
      </p>
      <ul style={{ 
  marginBottom: '15px',
  paddingLeft: '20px',
  fontSize: '15px',
  listStyleType: 'disc',
  display: 'block'
}}>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Voucher(s) are valid for a one-time use only.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Voucher(s) cannot be used in parts. If the order value is less than the voucher value, the remaining balance gets lapsed.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    If the order value is higher than the voucher value, the additional amount is payable at the time of check-out.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Any applicable GST and shipping charges are payable at the time of check-out.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Vouchers must be used before the "valid up-to date", else the voucher gets lapsed.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Voucher(s) cannot be redeemed for Cash.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Users can use each voucher to log in a maximum of 3 times. If the voucher is not redeemed within 3 attempts, the voucher gets deactivated.
  </li>
</ul>


      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        5. Redemption of Credits:
      </h3>
      <p style={{ marginBottom: '10px', fontSize: '15px' }}>
        B2B Clients can make purchases using available credits in their account. Redemption of the credits shall be strictly as per the 'Terms of Redemption' specified for their Business Account. 
      </p>
      <ul style={{ 
  marginBottom: '15px',
  paddingLeft: '20px',
  fontSize: '15px',
  listStyleType: 'disc',
  display: 'block'
}}>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Clients can request for credits through the 'my credits' section of their account.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    On Approval, the requested credits are added in the Clients Account.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Credits can be used only to purchase of goods and services listed on the website.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    If the order value is higher than the available credits, the additional amount is payable at the time of check-out.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Any applicable GST and shipping charges are payable at the time of check-out.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Credits must be used before the "valid up-to date", else the credits get lapsed.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Credits are non-transferable and cannot be redeemed for cash.
  </li>
</ul>


      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        6. Prohibited Activities:
      </h3>
      <p style={{ marginBottom: '10px', fontSize: '15px' }}>
        You agree not to:
      </p>
      <ul style={{ 
  marginBottom: '15px',
  paddingLeft: '20px',
  fontSize: '15px',
  listStyleType: 'disc',
  display: 'block'
}}>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Use the website for any illegal, unauthorized, or fraudulent purposes.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Interfere with the proper functioning of the website or attempt to gain unauthorized access to any portion or feature of the website.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Upload or transmit any viruses, malware, or other malicious code.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Violate any applicable laws, regulations, or third-party rights.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    Engage in any activity that may harm or disrupt the website or our services.
  </li>
</ul>


      <h2 style={{ 
        color: '#2c3e50',
        margin: '25px 0 15px 0',
        fontWeight: '600',
        fontSize: '22px'
      }}>
        Product Listings and Orders
      </h2>

      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        7. Product Information:
      </h3>
      <p style={{ marginBottom: '15px', fontSize: '15px' }}>
        We strive to provide accurate and up-to-date product information on our website. However, we do not warrant that the product descriptions, images, pricing, or other content on the website are complete, reliable, or error-free. We reserve the right to correct any errors, inaccuracies, or omissions and to change or update information at any time without prior notice.
      </p>

      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        8. Orders and Payments:
      </h3>
      <p style={{ marginBottom: '15px', fontSize: '15px' }}>
        By placing an order through our website, you make an offer to purchase the products or services selected. We reserve the right to accept any order at our discretion. Upon placing an order, you agree to provide accurate and complete payment information. You authorize us to charge the applicable fees to your selected payment method.
      </p>

      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        9. Shipping and Delivery:
      </h3>
      <p style={{ marginBottom: '15px', fontSize: '15px' }}>
      Shipping and delivery times may vary based on factors beyond our control. We will make reasonable efforts to fulfil and deliver your orders promptly, usually within 3-7days. However, we do not guarantee specific delivery dates or times. Risk of loss and title for products pass to you upon our delivery to the carrier.
      </p>

      <h2 style={{ 
        color: '#2c3e50',
        margin: '25px 0 15px 0',
        fontWeight: '600',
        fontSize: '22px'
      }}>
        Intellectual Property
      </h2>

      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        10. Ownership:
      </h3>
      <p style={{ marginBottom: '15px', fontSize: '15px' }}>
        All content and materials available on the website, including but not limited to text, graphics, logos, images, audio clips, videos, and software, are the property of the Company or its licensors and are protected by applicable intellectual property laws. You may not use, reproduce, modify, distribute, or display any portion of the website without our prior written consent.
      </p>

      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        11. Trademarks:
      </h3>
      <p style={{ marginBottom: '15px', fontSize: '15px' }}>
        One Up Shop, One Up Trade, our logos, and other trademarks, service marks, or trade names used on the website are owned by the Company. You may not use any of these marks without our prior written permission.
      </p>

      <h2 style={{ 
        color: '#2c3e50',
        margin: '25px 0 15px 0',
        fontWeight: '600',
        fontSize: '22px'
      }}>
        Returns and Exchanges
      </h2>

      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        12. No Return or Exchange Policy:
      </h3>
      <p style={{ marginBottom: '10px', fontSize: '15px' }}>
        All sales of goods purchased on our website are final. We do not accept returns or exchanges except in cases where the goods are genuinely received in a damaged or non-functional condition. If you encounter such issues:
      </p>
      <ul style={{ 
  marginBottom: '10px',
  paddingLeft: '20px',
  fontSize: '15px',
  listStyleType: 'disc',
  display: 'block'
}}>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    <strong>Damaged Goods:</strong> Write to us at support@oneupshop.in  within 7 days of delivery, providing detailed information and supporting evidence, such as pictures or videos taken at the time of unboxing the package.
  </li>
  <li style={{ marginBottom: '5px', display: 'list-item' }}>
    <strong>Non-Functional Goods:</strong> Write to us at support@oneupshop.in  within 7 days of delivery, providing detailed information and supporting evidence, including pictures or videos demonstrating the non-functionality.
  </li>
</ul>

      <p style={{ marginBottom: '15px', fontSize: '15px' }}>
        We reserve the right to determine the validity of any claims based on the evidence provided and will address them in accordance with our return and exchange policy.
      </p>

      <h2 style={{ 
        color: '#2c3e50',
        margin: '25px 0 15px 0',
        fontWeight: '600',
        fontSize: '22px'
      }}>
        Disclaimers and Limitations of Liability
      </h2>

      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        13. Disclaimers:
      </h3>
      <p style={{ marginBottom: '15px', fontSize: '15px' }}>
        The website and its content are provided on an "as is" and "as available" basis. We make no representations or warranties of any kind, express or implied, regarding the operation of the website or the information, content, materials, or products included on the website. To the fullest extent permissible by applicable law, we disclaim all warranties, express or implied, including, but not limited to, implied warranties of merchantability and fitness for a particular purpose.
      </p>

      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        14. Liability for Unauthorized Redemption:
      </h3>
      <p style={{ marginBottom: '15px', fontSize: '15px' }}>
        The Company is not liable for any unauthorized redemption of vouchers or account credits resulting from negligence or failure to maintain the confidentiality of credentials by users. It is the responsibility of users to ensure the security of their login information, account details, vouchers, and One-Time Passwords (OTPs). Any unauthorized access or transactions made using compromised credentials or OTPs are not the responsibility of the Company.
      </p>

      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        15. Limitation of Liability:
      </h3>
      <p style={{ marginBottom: '15px', fontSize: '15px' }}>
        To the fullest extent permissible by applicable law, we will not be liable for any damages of any kind arising from the use of the website, including, but not limited to, direct, indirect, incidental, punitive, and consequential damages. This limitation of liability applies to all damages, including, but not limited to, damages for loss of profits, loss of data, or loss of goodwill.
      </p>

      <h2 style={{ 
        color: '#2c3e50',
        margin: '25px 0 15px 0',
        fontWeight: '600',
        fontSize: '22px'
      }}>
        General
      </h2>

      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        16. Changes to Terms:
      </h3>
      <p style={{ marginBottom: '15px', fontSize: '15px' }}>
        We reserve the right to modify these Terms at any time. Any changes will be effective immediately upon posting on the website. Your continued use of the website following the posting of changes constitutes your acceptance of such changes.
      </p>

      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        17. Jurisdiction:
      </h3>
      <p style={{ marginBottom: '15px', fontSize: '15px' }}>
        Any disputes arising out of or relating to these Terms, the website, or any products or services provided by One Up Trade Pvt Ltd. shall be subject to the exclusive jurisdiction of the courts in Delhi/ New Delhi.
      </p>

      <h3 style={{ 
        color: '#2c3e50',
        margin: '20px 0 10px 0',
        fontWeight: '600',
        fontSize: '18px'
      }}>
        18. Contact Us:
      </h3>
      <p style={{ marginBottom: '15px', fontSize: '15px' }}>
        If you have any questions or concerns about these Terms, please contact us at support@oneupshop.in.
      </p>

      <div className="mt-4 p-3" style={{ 
        backgroundColor: '#f8f9fa',
        borderRadius: '5px',
        borderLeft: '4px solid #3498db',
        fontStyle: 'italic',
        fontSize: '15px'
      }}>
        <p style={{ marginBottom: '0' }}>
          By using our website, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
        </p>
      </div>
    </div>
                </section>
              </div>
            </div>
          </div>
        </section>
        <Footer />
        {/* </div> */}

        {/* <Footer /> */}

        {/* footer start */}
     
      </div>
    </div>
  );
};
export default Termsconditions;